<template>
  <div>
    <!-- 批量修改 -->
    <el-dialog
      title="批量修改选中商品的信息"
      :visible.sync="DialogVisible"
      width="600px"
      center
    >
      <el-form label-width="120px">
        <el-form-item label="字段名：">
          <el-select
            style="width: 300px"
            v-model="dialogValue"
            filterable
            placeholder="请选择需要修改的字段名"
          >
            <el-option
              v-for="item in dialogColumn"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="修改为："
          v-if="
            dialogValue != 'class_no' &&
            dialogValue != 'offlineclass' &&
              dialogValue != 'weight_flag' &&
              dialogValue != 'production_day'
          "
        >
          <el-input
            style="width: 300px"
            placeholder="输入修改后的值"
            v-model="dialog_change"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="dialogValue == 'class_no'" label="选择类别：">
          <wty-select
            id="1"
            :width="300"
            :who="dialogValue"
            @getReturn="getReturn"
          ></wty-select>
        </el-form-item>
        <el-form-item v-if="dialogValue == 'offlineclass'" label="选择线下类别：">
          <wty-select
            id="1"
            :width="300"
            :who="dialogValue"
            @getReturn="getReturn"
          ></wty-select>
        </el-form-item>
        <el-form-item
          v-if="dialogValue == 'weight_flag'"
          label="选择商品类型："
        >
          <wty-select
            id="1"
            :width="300"
            :who="dialogValue"
            @getReturn="getReturn"
          ></wty-select>
        </el-form-item>
        <el-form-item label="生产日期" v-if="dialogValue == 'production_day'">
          <el-date-picker
            v-model="dialog_change"
            type="date"
            placeholder="选择生产日期"
          >
          </el-date-picker>
        </el-form-item>
        <!-- <el-form-item v-if="dialogValue == 'barcode'" label="执行操作：">
          <el-checkbox-group
            v-model="checkedCities"
            @change="handleCheckedCitiesChange"
          >
            <el-checkbox v-for="item in radioList" :label="item" :key="item">{{
              city
            }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="bindDetermine">确 定</el-button>
        <el-button @click="changeModal('DialogVisible', false)"
          >取 消</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="格式化售价"
      :visible.sync="bulkModify"
      width="600px"
      center
    >
      <el-form label-width="150px">
        <el-form-item label="售价：" v-if="sheetwho == 'insheet'">
          <el-switch
            v-model="formatsp_data.amount"
            active-text="售价等于进价"
            inactive-text="售价不等于进价"
          ></el-switch>
        </el-form-item>

        <el-form-item v-if="!formatsp_data.amount" label="加点数：">
          <el-input
            placeholder="请输入加点数（例如加30个点输入30）"
            v-model="formatsp_data.point"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="!formatsp_data.amount" label="小数点后改为：">
          <div style="display: flex">
            <div
              style="margin-right: 10px;"
              v-for="(item, index) in formatsp_data.change_to"
              :key="index"
            >
              <input
                class="dyh-input"
                style=""
                v-model="formatsp_data.change_to[index]"
              />
            </div>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="formatSalePrice">确 定</el-button>
        <el-button @click="bindCancelTask">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import wtySelect from "./wty-select.vue";
import { goodsSelectColumn } from "@/js/sheettablecolumn.js";
export default {
  name: "selectEdit",
  components: { wtySelect },
  props: ["who", "sheetwho"],
  data() {
    return {
      // 是否显示基本信息
      DialogVisible: false,
      bulkModify: false, //售价
      dialog_change: "",
      dialogValue: "",
      dialogColumn: [],
      /* 格式化售价 */
      formatsp_data: {
        amount: false,
        point: "",
        change_to: [0, 5, 8, 9]
      }
    };
  },
  mounted() {
    if (this.who == "goodsinfo") {
      this.dialogColumn = [];
      this.dialogColumn = goodsSelectColumn;
    } else {
      this.dialogColumn = [
        {
          label: "类别",
          value: "offlineclass"
        },
        {
          label: "生产日期",
          value: "production_day"
        }
      ];
    }
  },
  methods: {
    /**
     *
     * @param {*} key "DialogVisible" 基本信息modal | "bulkModify" 价格 modal
     * @param {*} value true | false
     */
    changeModal(key, value) {
      if (key == "DialogVisible") {
        this.DialogVisible = value;
      } else if (key == "bulkModify") {
        this.bulkModify = value;
      }
    },

    //获取修改的返回值
    getReturn({ who, value }) {
      console.log(who,value);
      // console.log(key);
      this.dialog_change = value;
      // this.dialogValue = "";
    },
    // 点击确定按钮
    bindDetermine() {
      console.log("dialog_change", this.dialog_change);
      if (this.dialogValue == "production_day") {
        this.dialog_change = this.requestDate(this.dialog_change);
      }
      if (this.dialogValue == "offlineclass") {
        this.dialogValue = "class_no";
      }
      this.$emit("bindDetermine", {
        key: this.dialogValue,
        value: this.dialog_change
      });
      this.dialog_change = "";
      this.dialogValue = "";
    },
    //价格
    formatSalePrice() {
      this.$emit("formatSalePrice", this.formatsp_data);
      this.dialog_change = "";
      this.dialogValue = "";
    },
    //价格取消
    bindCancelTask() {
      this.bulkModify = false;
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.el-input {
  width: 300px !important;
  min-width: 300px !important;
}

.dyh-input {
  width: 50px !important;
  max-width: 50px !important;
  height: 100%;
  border: 1px solid#DCDFE6;
  border-radius: 5px;
  padding-left: 10px;
}
.dyh-input:focus{
  border: 0.5px solid #53A8FF;
  outline: 0.5px solid #C6E2FF;
  
}
</style>
